 import { create } from 'zustand'

 const WIDE_START_BASELINE = 3225; // start session with wider-teeth-friendly value
const WIDE_END_BASELINE = 20000;

const initial = {
  startStop: WIDE_START_BASELINE,
  initialStartStop: WIDE_START_BASELINE,
  endStop: WIDE_END_BASELINE,
  initialEndStop: WIDE_END_BASELINE,
}

type TeethSelectionState = typeof initial & {
  setStartStop: (n: number) => void
  setEndStop: (n: number) => void
  reset: () => void
}

export const teethSelectionStore = create<TeethSelectionState>((set) => ({
  ...initial,
  setStartStop: (startStop) => set({ startStop }),
  setEndStop: (endStop) => set({ endStop }),
  reset: () => set({ ...initial }),
}))
